import {
  SURVEY_STATUS,
  HighCpiConfirmationDetails,
  SurveyStatus,
} from '@ps/survey-kernel';
import {
  HIGH_CPI_CONFIRMATION_MESSAGES,
  MAX_CPI_THRESHOLD,
} from '../constants/high-cpi-confirmation.constants';

export type SurveyHighCpiApiConfirmationContext = {
  readonly type: 'high-cpi-data';
  readonly nextStatus: SurveyStatus;
  readonly highCpiDetails: HighCpiConfirmationDetails;
  readonly isProject?: boolean;
};

export type SurveyHighCpiEnteredConfirmationContext = {
  readonly type: 'survey-data';
  readonly cpi: number;
  readonly currencySymbol: string;
};

export type SurveyHighCpiConfirmationContext =
  | SurveyHighCpiApiConfirmationContext
  | SurveyHighCpiEnteredConfirmationContext;

export class SurveyHighCpiConfirmationInspector {
  public constructor(
    private readonly _context: SurveyHighCpiConfirmationContext,
  ) {}

  public check(): boolean {
    if (this._context.type === 'high-cpi-data') {
      return (
        this._context.nextStatus === SURVEY_STATUS.LIVE &&
        !!this._context.highCpiDetails.isPriceGreaterThanCpiThreshold
      );
    }

    return this._context.cpi > MAX_CPI_THRESHOLD;
  }

  public text(): string {
    if (this._context.type === 'high-cpi-data') {
      const template = this._context.isProject
        ? HIGH_CPI_CONFIRMATION_MESSAGES.project
        : HIGH_CPI_CONFIRMATION_MESSAGES.survey;

      const { value, currency } = this._context.highCpiDetails.pricingDetails;

      return template
        .replace('<CPI>', value)
        .replace('<CURRENCY_SYMBOL>', currency || '$');
    }

    return HIGH_CPI_CONFIRMATION_MESSAGES.survey
      .replace('<CPI>', `${this._context.cpi}`)
      .replace('<CURRENCY_SYMBOL>', this._context.currencySymbol || '$');
  }
}
